

const API_URL = 'https://kritics-api.krisloertscher.workers.dev/api/kritics';

export const getKritics = async (page = 1, limit = 25, sort = 'match_score:desc', search = '', userId) => {
  const params = new URLSearchParams({
    page,
    limit,
    sort,
    search
  });
  if (userId) params.append('userId', userId);

  try {
    const response = await fetch(`${API_URL}?${params.toString()}`);
    if (!response.ok) {
      throw new Error('Failed to fetch kritics');
    }
    return response.json();
  } catch (error) {
    console.error('Error fetching kritics:', error);
    throw error;
  }
};

export const getKriticDetails = async (siteIdentifier, userId) => {
  let url = `${API_URL}/${siteIdentifier}`;
  if (userId) {
    url += `?userId=${userId}`;
  }

  try {
    const response = await fetch(url);
    if (!response.ok) {
      let errorMessage = 'Failed to fetch kritic details';
      try {
        const errorData = await response.json();
        errorMessage = errorData.error || errorData.message || errorMessage;
      } catch (e) {
        // Response body wasn't JSON
      }
      throw new Error(errorMessage);
    }
    return response.json();
  } catch (error) {
    console.error(`Error fetching kritic details for ${siteIdentifier}:`, error);
    throw error;
  }
};
